if (!customElements.get('firmwell-product-hero')) {
  customElements.define('firmwell-product-hero', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort(); this.events = new AbortController();
      const { signal } = this.events;
      this.slides = [...this.querySelectorAll('[data-fph-slide]')];
      if (!this.slides.length) return;
      this.buttons = [...this.querySelectorAll('[data-fph-select]')];
      this.pauseButton = this.querySelector('[data-fph-pause]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced.matches;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      this.index = 0; this.hovered = false; this.inView = true; this.loading = false;
      this.querySelector('[data-fph-controls]').hidden = false;
      this.dataset.current = '0';
      this.buttons.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.fphSelect)), { signal }));
      this.querySelector('[data-fph-prev]').addEventListener('click', () => this.show(this.index - 1), { signal });
      this.querySelector('[data-fph-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
      this.pauseButton.addEventListener('click', () => { this.autoplay = !this.autoplay; this.syncPause(); }, { signal });
      this.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover) and (pointer: fine)').matches) { this.hovered = true; clearTimeout(this.timer); } }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => clearTimeout(this.timer), { signal });
      this.addEventListener('focusout', () => { clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => this.schedule(), 0); }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, { signal });
      this.querySelector('.fph-stage').addEventListener('touchstart', event => {
        const touch = event.touches[0]; this.touchStart = { x: touch.clientX, y: touch.clientY }; clearTimeout(this.timer);
      }, { passive: true, signal });
      this.querySelector('.fph-stage').addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const touch = event.changedTouches[0], x = touch.clientX - this.touchStart.x, y = touch.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.25) this.show(this.index + (x < 0 ? 1 : -1));
        else this.schedule();
      }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => {
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced.matches;
        if (this.reduced.matches) this.animations?.forEach(a => a.cancel());
        this.syncPause();
      }, { signal });
      this.intersection = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .1 });
      this.intersection.observe(this);
      this.sizeObserver = new ResizeObserver(() => this.sizeHero());
      const header = document.querySelector('.fw-header'); if (header) this.sizeObserver.observe(header);
      window.addEventListener('resize', () => this.sizeHero(), { passive: true, signal });
      document.addEventListener('shopify:section:select', event => { if (event.target.contains(this)) { this.autoplay = false; this.syncPause(); } }, { signal });
      this.sizeHero(); this.syncPause(); this.animateSlide(this.slides[0]);
      this.preloadTimer = setTimeout(() => this.slides.slice(1).forEach(slide => { slide.querySelector('img').loading = 'eager'; }), 1500);
    }
    sizeHero() { this.style.setProperty('--fph-top', Math.max(0, Math.min(240, this.getBoundingClientRect().top + scrollY)) + 'px'); }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || this.hovered || !this.inView || document.hidden || this.matches(':focus-within') || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => { if (document.querySelector('dialog[open]')) this.schedule(); else this.show(this.index + 1, false); }, this.interval);
    }
    syncPause() {
      this.pauseButton.setAttribute('aria-label', this.autoplay ? 'Pause automatic slideshow' : 'Play automatic slideshow');
      this.querySelector('[data-fph-pause-icon]').toggleAttribute('hidden', !this.autoplay);
      this.querySelector('[data-fph-play-icon]').toggleAttribute('hidden', this.autoplay);
      this.schedule();
    }
    async show(index, manual = true) {
      if (this.loading) return;
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.index) { this.schedule(); return; }
      this.loading = true; clearTimeout(this.timer);
      const image = this.slides[next].querySelector('img'); image.loading = 'eager';
      try { await image.decode(); } catch (_) { /* Keep native image fallback and its descriptive alt. */ }
      if (!this.isConnected) return;
      const focusWasInSlide = this.slides[this.index].contains(document.activeElement);
      this.index = next;
      this.slides.forEach((slide, i) => { slide.hidden = i !== next; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === next)));
      this.dataset.current = String(next);
      document.dispatchEvent(new CustomEvent('firmwell:hero-change'));
      if (manual) this.querySelector('[data-fph-status]').textContent = this.slides[next].dataset.title;
      if (focusWasInSlide) this.buttons[next].focus({ preventScroll: true });
      this.animateSlide(this.slides[next]); this.loading = false; this.schedule();
    }
    animateSlide(slide) {
      this.animations?.forEach(a => a.cancel()); this.animations = [];
      if (this.reduced.matches || !slide.animate) return;
      slide.querySelectorAll('.fph-line>span').forEach((element, i) => this.animations.push(element.animate([{ transform: 'translateY(112%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 680, delay: i * 85, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' })));
      for (const [selector, delay] of [['.fph-eyebrow',40],['.fph-description',120],['.fph-shop',220],['.fph-note',260]]) {
        const element = slide.querySelector(selector);
        if (element) this.animations.push(element.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' }));
      }
      this.animations.push(slide.querySelector('img').animate([{ opacity: .65, transform: 'scale(1.025)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 850, easing: 'ease-out' }));
      this.animations.forEach(a => a.finished.catch(() => {}));
    }
    disconnectedCallback() {
      this.events?.abort(); this.intersection?.disconnect(); this.sizeObserver?.disconnect();
      clearTimeout(this.timer); clearTimeout(this.preloadTimer); clearTimeout(this.focusTimer);
      this.animations?.forEach(a => a.cancel());
    }
  });
}
